import React from 'react';
import { View } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';

import ListItem from '../../../../Components/ListItem';
import themeStyle from '../../../../Theme/styles';

const PillButton = ({ capitalize, selected, title, ...props }: any) => {
  const theme = useTheme();
  return (
    <View style={themeStyle.flexDirectionRow}>
      <ListItem
        contentContainerStyle={[
          themeStyle.pageVerticalSpacingSmall,
          themeStyle.pageHorizontalSpacingSmall,
          {
            borderWidth: 1,
            borderColor: selected
              ? theme['color-info-500']
              : theme['color-primary-500'],
            borderRadius: 20,
          },
          selected && { backgroundColor: theme['color-info-500'] },
        ]}
        flex={false}
        title={
          <Text
            appearance={selected ? 'alternative' : 'default'}
            category="label"
            style={capitalize && themeStyle.capitalize}
          >
            {title}
          </Text>
        }
        {...props}
      />
    </View>
  );
};

export default PillButton;
